import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { LOCALE_OPTIONS } from '../../../misc/Constants'
import { updateCommunityLocale } from '../../../actions/communitiesActions'
import Loader from '../../common/loader/legacy-loaders/Op36Loader-web'

const GeneralTab = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const currentUser = useSelector(state => state.user.current_user)
  const community = currentUser.communities[0]

  const [locale, setLocale] = useState(community?.locale || 'en')

  if (!community) {
    return <Loader message={t('communitySettings.page.loading')} />
  }

  const handleSave = () => {
    dispatch(updateCommunityLocale(community.id, locale, currentUser.id))
      .then(() => toast.success(t('communitySettings.generalTab.languageUpdated')))
      .catch(() => toast.error(t('communitySettings.common.genericError')))
  }

  return (
    <form className={classNames('py-4 px-3')} onSubmit={(e) => { e.preventDefault(); handleSave() }}>
      <div className='pb-4'>
        <label htmlFor='locale'>{t('common.language')}</label>
        <select
          id='locale'
          className='form-control'
          style={{ borderRadius: '8px' }}
          value={locale}
          onChange={(e) => setLocale(e.target.value)}
        >
          {LOCALE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <button type='submit' className='btn btn-primary'>
        {t('common.save')}
      </button>
    </form>
  )
}

export default GeneralTab
